module.exports = __webpack_public_path__ + "static/saltmarsh-world-983a7f2ec6b8fbdd0f90947861cf3b9f.png";